import { IFilter } from "../shared/ifilter";
import { ICArea } from "../entities/icarea";

export class ICAreaFilter implements IFilter<ICArea> {
  AreaIds: number[];
  Count: number;
  CurrentPage: number;
  CustomFilter: number[];
  Level: number;
  OnlyFather: boolean;
  PerPage: number;
  Sort: number;
  SortType: number;
  UsePagination: boolean;
  SearchQuery: string;

  UserId: number;

  constructor(data?: Partial<ICAreaFilter>) {
    Object.assign(this, data);
  }
}
